module.exports = __webpack_public_path__ + "static/media/profile.dbad7065.svg";